// Default Wordpress Details block
// open details block on enter key press

const detailsDefaultBlock = () => {
	document.querySelectorAll('details summary').forEach(summary => {
		summary.addEventListener('keydown', (event) => {
			if (event.key === 'Enter') {
				event.preventDefault();
				// simulate a click event on the details element
				this.parentElement.click();
			}
		});
	});
    

};

export default detailsDefaultBlock;